import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=2770df9c&scoped=true&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770df9c",
  null
  
)

export default component.exports